import { create } from 'zustand';

interface TurnAlertState {
  pendingHumanTurnCount: number;
  pendingHumanTurnGameIds: string[];
  setPendingHumanTurns: (gameIds: string[]) => void;
}

export const useTurnAlertStore = create<TurnAlertState>((set) => ({
  pendingHumanTurnCount: 0,
  pendingHumanTurnGameIds: [],
  setPendingHumanTurns: (gameIds) => set({
    pendingHumanTurnCount: gameIds.length,
    pendingHumanTurnGameIds: gameIds,
  }),
}));
